import React from "react";
import { Route } from "react-router-dom";

import PrivateRoute from "./components/PrivateRoute";

import LoginForm from "./components/login/LoginForm";

import UploadCsv from "./components/csv/UploadCsv";
import CsvList from "./components/csv/CsvList";

import DomainsList from "./features/domain/components/pages/DomainsList";
import CreateDomain from "./features/domain/components/pages/CreateDomain";
import EditDomain from "./features/domain/components/pages/EditDomain";

import CategoriesList from "./features/categories/components/CategoriesList";
import CreateCategory from "./features/categories/components/CreateCategory";
import EditCategory from "./features/categories/components/EditCategory";

import PagesList from "./features/pages/components/pages/PagesList";
import CreatePage from "./features/pages/components/pages/CreatePage";
import EditPage from "./features/pages/components/pages/EditPage";

import Products from "./features/product/components/pages/Products";
import EditProduct from "./features/product/components/pages/EditProduct";
import CreateProduct from "./features/product/components/pages/CreateProduct";

import TagsList from "./features/tags/components/TagsList";
import CreateTag from "./features/tags/components/CreateTag";
import EditTag from "./features/tags/components/EditTag";

import AreasList from "./features/area/components/pages/AreasList";
import CreateArea from "./features/area/components/pages/CreateArea";
import EditArea from "./features/area/components/pages/EditArea";

import MenusList from "./features/menu/components/pages/MenusList";
import CreateMenu from "./features/menu/components/pages/CreateMenu";
import EditMenu from "./features/menu/components/pages/EditMenu";

import ColumnsList from "./features/columns/components/pages/ColumnsList";
import CreateColumn from "./features/columns/components/pages/CreateColumn";
import EditColumn from "./features/columns/components/pages/EditColumn";

import MenuItemsList from "./features/menuItem/components/pages/MenuItemsList";
import CreateMenuItem from "./features/menuItem/components/pages/CreateMenuItem";
import EditMenuItem from "./features/menuItem/components/pages/EditMenuItem";

import SettingEditForm from "./features/settingDefinition/components/pages/SettingDefinitionEdit";
import SettingCreateForm from "./features/settingDefinition/components/pages/SettingDefinitionCreate";
import SettingDefinitionsList from "./features/settingDefinition/components/pages/SettingDefinitionsList";

const routes = (
  <Route>
    {/* Login */}
    <Route path="/login" element={<LoginForm />} />

    {/* Protected Routes */}
    <Route
      path="/csv/upload"
      element={
        <PrivateRoute>
          <UploadCsv />
        </PrivateRoute>
      }
    />

    <Route
      path="/csv"
      element={
        <PrivateRoute>
          <CsvList />
        </PrivateRoute>
      }
    />

    <Route
      path="/"
      element={
        <PrivateRoute>
          <DomainsList />
        </PrivateRoute>
      }
    />

    <Route
      path="/domains"
      element={
        <PrivateRoute>
          <DomainsList />
        </PrivateRoute>
      }
    />
    <Route
      path="/domains/create"
      element={
        <PrivateRoute>
          <CreateDomain />
        </PrivateRoute>
      }
    />
    <Route
      path="/domains/edit/:id"
      element={
        <PrivateRoute>
          <EditDomain />
        </PrivateRoute>
      }
    />

    <Route
      path="/categories"
      element={
        <PrivateRoute>
          <CategoriesList />
        </PrivateRoute>
      }
    />
    <Route
      path="/categories/create"
      element={
        <PrivateRoute>
          <CreateCategory />
        </PrivateRoute>
      }
    />
    <Route
      path="/categories/edit/:id"
      element={
        <PrivateRoute>
          <EditCategory />
        </PrivateRoute>
      }
    />

    <Route
      path="/pages"
      element={
        <PrivateRoute>
          <PagesList />
        </PrivateRoute>
      }
    />
    <Route
      path="/pages/create"
      element={
        <PrivateRoute>
          <CreatePage />
        </PrivateRoute>
      }
    />
    <Route
      path="/pages/edit/:id"
      element={
        <PrivateRoute>
          <EditPage />
        </PrivateRoute>
      }
    />

    <Route
      path="/products"
      element={
        <PrivateRoute>
          <Products />
        </PrivateRoute>
      }
    />

    <Route
      path="/product/create"
      element={
        <PrivateRoute>
          <CreateProduct />
        </PrivateRoute>
      }
    />

    <Route
      path="/product/edit/:id"
      element={
        <PrivateRoute>
          <EditProduct />
        </PrivateRoute>
      }
    />

    <Route
      path="/tags"
      element={
        <PrivateRoute>
          <TagsList />
        </PrivateRoute>
      }
    />
    <Route
      path="/tags/create"
      element={
        <PrivateRoute>
          <CreateTag />
        </PrivateRoute>
      }
    />
    <Route
      path="/tags/edit/:id"
      element={
        <PrivateRoute>
          <EditTag />
        </PrivateRoute>
      }
    />

    <Route
      path="/areas"
      element={
        <PrivateRoute>
          <AreasList />
        </PrivateRoute>
      }
    />
    <Route
      path="/areas/create"
      element={
        <PrivateRoute>
          <CreateArea />
        </PrivateRoute>
      }
    />
    <Route
      path="/areas/edit/:id"
      element={
        <PrivateRoute>
          <EditArea />
        </PrivateRoute>
      }
    />

    <Route
      path="/menus"
      element={
        <PrivateRoute>
          <MenusList />
        </PrivateRoute>
      }
    />
    <Route
      path="/menus/create"
      element={
        <PrivateRoute>
          <CreateMenu />
        </PrivateRoute>
      }
    />
    <Route
      path="/menus/edit/:id"
      element={
        <PrivateRoute>
          <EditMenu />
        </PrivateRoute>
      }
    />

    <Route
      path="/columns"
      element={
        <PrivateRoute>
          <ColumnsList />
        </PrivateRoute>
      }
    />
    <Route
      path="/columns/create"
      element={
        <PrivateRoute>
          <CreateColumn />
        </PrivateRoute>
      }
    />
    <Route
      path="/columns/edit/:id"
      element={
        <PrivateRoute>
          <EditColumn />
        </PrivateRoute>
      }
    />

    <Route
      path="/menu-items"
      element={
        <PrivateRoute>
          <MenuItemsList />
        </PrivateRoute>
      }
    />
    <Route
      path="/menu-items/create"
      element={
        <PrivateRoute>
          <CreateMenuItem />
        </PrivateRoute>
      }
    />
    <Route
      path="/menu-items/edit/:id"
      element={
        <PrivateRoute>
          <EditMenuItem />
        </PrivateRoute>
      }
    />

    <Route
      path="/setting-definitions"
      element={
        <PrivateRoute>
          <SettingDefinitionsList />
        </PrivateRoute>
      }
    />
    <Route
      path="/setting-definition/create"
      element={
        <PrivateRoute>
          <SettingCreateForm />
        </PrivateRoute>
      }
    />
    <Route
      path="/setting-definition/edit/:id"
      element={
        <PrivateRoute>
          <SettingEditForm />
        </PrivateRoute>
      }
    />
  </Route>
);

export default routes;
